var _Byte_value;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import Exception from '../../Exceptions/Exception';
import { ensureInt } from "./ensureInt";
import Result from '../../Result/Result';
/**
 * Represents an unsigned 8-bit integer.
 */
export default class Byte extends Number {
    constructor(value) {
        super(value);
        _Byte_value.set(this, void 0);
        ensureInt(value, Byte.minValue, Byte.maxValue);
        __classPrivateFieldSet(this, _Byte_value, value, "f");
    }
    [(_Byte_value = new WeakMap(), Symbol.toPrimitive)]() {
        return this.valueOf();
    }
    valueOf() {
        return __classPrivateFieldGet(this, _Byte_value, "f").valueOf() & 0xFF;
    }
    toString() {
        return this.valueOf().toString();
    }
    static parse(value) {
        const int = parseInt(value);
        return new Byte(int);
    }
    static tryParse(value) {
        const int = parseInt(value);
        try {
            ensureInt(int, Byte.minValue, Byte.maxValue);
            return Result.ok(new Byte(int));
        }
        catch (ex) {
            if (ex instanceof Exception) {
                return Result.fail(ex.message);
            }
            else if (ex instanceof Error) {
                return Result.fail(ex.message);
            }
            else {
                return Result.fail(`${ex}`);
            }
        }
    }
}
/** The largest number that can be represented. Equal to 255. */
Byte.maxValue = 255;
/** The lowest number that can be represented. Equal to 0. */
Byte.minValue = 0;
